<template>
  <div
    class="edit-wp-dialog-outside"
    @click="$emit('closeDialog')"
    >
    <div
      class="edit-twp-dialog grey darken-3"
      @click.prevent.stop
      >
      <v-btn
        icon
        class="edit-wp-dialog-close-btn"
        @click="$emit('closeDialog')"
        >
        <v-icon>cancel</v-icon>
      </v-btn>
      <div>Edit Workpackage</div>
      <div class="d-flex mt-3 pb-2" style="border-bottom: 1px solid white">
        <div style="width: 50%; display: flex; flex-direction: column; align-items: center">
          <div style="border: solid 1px white; padding: 2px; border-radius: 5px;">current settings</div>
          <Workpackage
            :workpackage="workpackage"
            :zoom="3"
          />
          <div>Name: {{workpackage.name}}</div>
        </div>
        <div style="width: 50%; display: flex; flex-direction: column; align-items: center">
          <div style="border: solid 1px white; padding: 2px; border-radius: 5px;">preview</div>
          <Workpackage
            :workpackage="new_workpackage"
            :zoom="3"
          />
          <div>Name: {{new_workpackage.name}}</div>
        </div>
      </div>
      <div class="d-flex mb-2 pa-2" style="display: flex; align-items: center;">
      <div>New Settings: </div>
        <v-btn
          class="ml-2"
          @click="
            new_workpackage.color = workpackage.color;
            new_workpackage.textcolor = workpackage.textcolor;
            new_workpackage.token = workpackage.token;
            new_workpackage.icon = workpackage.icon;
            new_workpackage.name = workpackage.name;
          "
          >
          reset
        </v-btn>
        <v-btn
          class="ml-4"
          color="green"
          @click="$emit('changeWP', {snackbar_call: snackbar_call, new_wp: new_workpackage})"
          >
          save changes
        </v-btn>
        <div v-if="!backlog" class="d-flex" style="align-items: center">
          <v-btn icon @click="snackbar_call = !snackbar_call">
            <v-icon>{{snackbar_call?'check_box':'check_box_outline_blank'}}</v-icon>
          </v-btn>
          <div>change for all same workpackages in train (<b>highly</b> recommended). </div>
          <div v-if="!snackbar_call" style="color: #f44336">Please leave on checked!</div>
          <div v-if="!snackbar_call" style="color: #4caf50">Unless you really know what you are doing.</div>
        </div>
      </div>
      <div class="d-flex">
        <div>Name: </div>
        <input
          class="edit-wp-dialog-name-input"
          :value="new_workpackage.name"
          @change="new_workpackage.name = $event.target.value"
        />
      </div>
      <div class="d-flex mt-2">
        <div>Token: </div>
        <input
          class="edit-wp-dialog-name-input"
          :value="new_workpackage.token"
          maxlength="3"
          @change="new_workpackage.token = $event.target.value.toUpperCase()"
        />
      </div>
      <div class="d-flex mt-3 align-center" style="width: 100%;">
        <div class="mr-2" >Icon:      </div>
        <SearchBar
          :is_live_emit="true"
          max_width="256"
          min_height = "40"
          @search="search_term = $event;"
        />
        <template v-if="selectedIsFavorite">
          <TTooltip value="remove from favorite">
            <v-btn class="mr-2" icon @click="remove_favorite_icons(new_workpackage.icon)">
              <TIcon name="star-filled"/>
            </v-btn>
          </TTooltip>
        </template>
        <template v-else>
          <TTooltip value="add to favorite">
            <v-btn class="mr-2" icon @click="add_favorite_icons(new_workpackage.icon)" >
              <TIcon name="star"/>
            </v-btn>
          </TTooltip>
        </template>
      </div>
      <template v-if="favorite_user_icons.length > 0">
        <div class="d-flex mt-3" style="width: 100%; flex-wrap: wrap;  overflow: auto">
          <WorkBenchWorkPackageIconPicker
            v-for="icon in favorite_user_icons"
            :key="icon.id"
            :icon="icon.id"
            :color="new_workpackage.color"
            :text_color="new_workpackage.textcolor"
            :selected_icon="new_workpackage.icon"
            @clickIcon="new_workpackage.icon = $event"
          />
        </div>
        <v-divider class="t-2 mt-3"></v-divider>
      </template>
      <div class="d-flex mt-3" style="width: 100%; flex-wrap: wrap; height: 120px; overflow: auto">
        <WorkBenchWorkPackageIconPicker
         v-for="icon in filtered_icons"
         :key="icon.id"
         :icon="icon.id"
         :color="new_workpackage.color"
         :text_color="new_workpackage.textcolor"
         :selected_icon="new_workpackage.icon"
         @clickIcon="new_workpackage.icon = $event"
         />
      </div>
      <div class="d-flex mt-3 align-center" style="width: 100%;">
        <div class="mr-2" >Color:</div>
          <template v-if="selectedColorIsFavorite">
            <TTooltip value="remove from favorite">
              <v-btn class="mr-2" icon @click="remove_favorite_colors(new_workpackage.color)">
                <TIcon name="star-filled"/>
                </v-btn>
            </TTooltip>
          </template>
          <template v-else>
            <TTooltip value="add to favorite">
              <v-btn class="mr-2" icon @click="add_favorite_colors(new_workpackage.color)" >
                <TIcon name="star"/>
              </v-btn>
            </TTooltip>
          </template>
      </div>
      <template v-if="favorite_user_colors.length > 0">
        <div class="d-flex mt-3" style="width: 100%; flex-wrap: wrap;  overflow: auto">
            <WorkBenchWorkPackageColorPicker
              class="ml-2"
              v-for="color in favorite_user_colors"
              :key="color.color"
              :color="color.color.split(' ')[0]"
              :selected_color="new_workpackage.color"
              :favorite_mode = "true"
              :favorite_color = color.color
              @clickColor="
                new_workpackage.color = $event.color,
                new_workpackage.textcolor = $event.text_color
              "
            />
        </div>
        <v-divider class="mt-3 mb-3"></v-divider>
      </template>
      <div class="d-flex" style="width: 100%; flex-wrap: wrap; height: 140px; overflow: auto">
        <WorkBenchWorkPackageColorPicker
          class="ml-2"
          v-for="color in [
            'red',
            'pink',
            'purple',
            'deep-purple',
            'indigo',
            'blue',
            'light-blue',
            'cyan',
            'teal',
            'green',
            'light-green',
            'lime',
            'yellow',
            'amber',
            'orange',
            'deep-orange',
            'brown',
            'blue-grey',
            'grey'
          ]"
          :key="color"
          :color="color"
          :selected_color="new_workpackage.color"
          @clickColor="
            new_workpackage.color = $event.color
            new_workpackage.textcolor = $event.text_color
          "
        />
      </div>
    </div>
  </div>
</template>
<script>
  // import { mapGetters } from 'vuex';
  import {mapGetters,mapActions } from 'vuex';
  import Workpackage from '@/components/ProjectTaktPlan/Workpackage.component.vue'
  import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
  import WorkBenchWorkPackageIconPicker from '@/components/WorkBench/WorkBenchWorkPackageIconPicker.component.vue'
  import WorkBenchWorkPackageColorPicker from '@/components/WorkBench/WorkBenchWorkPackageColorPicker.component.vue'
  import TIcon from '@/components/Taktify/TIcon.component.vue'

  export default {
    props: ['workpackage', 'backlog'],
    components: {
      Workpackage,
      WorkBenchWorkPackageIconPicker,
      WorkBenchWorkPackageColorPicker,
      SearchBar,
      TIcon
    },
    data: () => ({
      search_term: '',
      new_workpackage: {
        color: '',
        token: '',
        icon: '',
        name: '',
        textcolor: '',
      },
      snackbar_call: true,
      favorite_user_icons: [],
      favorite_user_colors: [],
    }),
    created() {
      this.new_workpackage.color = this.workpackage.color;
      this.new_workpackage.textcolor = this.workpackage.textcolor;
      this.new_workpackage.token = this.workpackage.token;
      this.new_workpackage.icon = this.workpackage.icon;
      this.new_workpackage.name = this.workpackage.name;
      this.request_favorite_icons();
      this.request_favorite_colors()
    },
    computed: {
      ...mapGetters('Auth', [
        'getUser',
        'hasPermission'
      ]),
      ...mapGetters('Ultra', [
        'getUObject',
        'getUObjects',
    ]),
      // ...mapGetters('WorkPackage', [
      //   'getWorkPackageIcons'
      // ]),
      filtered_icons() {
        let terms = this.search_term.split(' ');
        let ret = this.$store.state.Ultra.icons;
        terms.forEach(term => {
          // check if id contains search terms or any hashtag
          // gets faster for each consecutive term assuming ret gets smaller
          ret = ret.filter(element => element.id.includes(term) || element.hashtags.filter(hashtag => hashtag.includes(term)).length != 0)
        });
        return ret;
      },
      selectedIsFavorite(){
        let is_favorite = false
        this.favorite_user_icons.forEach(user_icon => {
          if(user_icon.id === this.new_workpackage.icon){
            is_favorite = true
          }
        })
        return is_favorite
      },
      selectedColorIsFavorite(){
        let is_favorite = false
        this.favorite_user_colors.forEach(user_color => {
          if(user_color.color === this.new_workpackage.color){
            is_favorite = true
          }
        })
        return is_favorite
      },
    },
    methods: {
      ...mapActions('Ultra', [
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'requestUObject'
      ]),
      request_favorite_icons() {
        this.requestUObject({
          url: [
            { users: this.getUser.id },
            { usericons: '' },
            { showWithEntitiesNormalized: ''}
          ],
          no_cache: true,
        }).then(() => {
          this.favorite_user_icons = this.read_favorite_icons()
        })
      },
      add_favorite_icons(icon){
        let duplicate = false
        this.favorite_user_icons.forEach(user_icon => {
          if(user_icon.id === icon){
            duplicate = true
          }
        })
        if(duplicate){
          return
        }
        this.createUObject({
          url: [
            { users: this.getUser.id },
            { usericons: '' },
            { showWithEntitiesNormalized: ''}
          ],
          u_object: {
            icon: icon
          },
          call_only : true,
          add_u_object: true
        }).then(() => {
          this.request_favorite_icons()
        })
      },
      remove_favorite_icons(icon){
        let is_favorite = false
        let target_icon
        this.favorite_user_icons.forEach(user_icon => {
          if(user_icon.id === icon){
            is_favorite = true
            target_icon = user_icon.obj_id
          }
        })
        if(!is_favorite){
          return
        }
        this.deleteUObject({
          url: [
            { users: this.getUser.id },
            { usericons: target_icon},
          ],
          call_only : true,
        }).then(() => {
          this.favorite_user_icons = this.read_favorite_icons()
        });
      },
      read_favorite_icons(){
        let icons = this.getUObjects({type: 'usericons'})
        let readable_icons = []
        icons.forEach(icon => {
          readable_icons.push({id: icon.icon, obj_id: icon.id})
        })
        return readable_icons
      },
      request_favorite_colors() {
        this.requestUObject({
          url: [
            { users: this.getUser.id },
            { usercolors: '' },
            { showWithEntitiesNormalized: ''}
          ],
          no_cache: true,
        }).then(() => {
          this.favorite_user_colors = this.read_favorite_colors()
        })
      },
      add_favorite_colors(color){
        let duplicate = false
        this.favorite_user_colors.forEach(user_color => {
          if(user_color.color === color){
            duplicate = true
          }
        })
        if(duplicate){
          return
        }
        this.createUObject({
          url: [
            { users: this.getUser.id },
            { usercolors: '' },
            { showWithEntitiesNormalized: ''}
          ],
          u_object: {
            color: color
          },
          call_only : true,
          add_u_object: true
        }).then(() => {
          this.request_favorite_colors()
        })
      },
      remove_favorite_colors(color){
        let is_favorite = false
        let target_color
        this.favorite_user_colors.forEach(user_color => {
          if(user_color.color === color){
            is_favorite = true
            target_color = user_color.obj_id
          }
        })
        if(!is_favorite){
          return
        }
        this.deleteUObject({
          url: [
            { users: this.getUser.id },
            { usercolors: target_color},
          ],
          call_only : true,
        }).then(() => {
          this.favorite_user_colors = this.read_favorite_colors()
        });
      },
      read_favorite_colors(){
        let colors = this.getUObjects({type: 'usercolors'})
        let readable_colors = []
        colors.forEach(color => {
          readable_colors.push({color: color.color, obj_id: color.id})
        })
        return readable_colors
      },

    }
  }
</script>
<style>
  .edit-wp-dialog-outside {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0px;
    top: 0px;
    z-index: 100;

  }
  .edit-twp-dialog {
    position: fixed;
    width: 90vw;
    height: 90vh;
    left: 5vw;
    top: 5vh;
    border-radius: 10px;
    cursor: default;
    padding: 5px;
  }
  .edit-wp-dialog-close-btn {
    position: absolute;
    right: 5px;
    top: 5px;
  }
  .edit-wp-dialog-name-input {
    background-color: white;
    border: black solid 1px;
    border-radius: 5px;
    margin-left: 5px;
    color: black;
    width: 400px;
  }
  .edit-wp-dialog-name-input:focus {
    outline: none;
  }
</style>
